import Snackbars from './Snackbars';

const SNACKBAR_TEMPLATES = {};
const templateMapping = new Map();

Object.entries(Snackbars).forEach(([key, snackbar]) => {
  const { templateId } = snackbar;
  const templateConstantKey = templateId.toUpperCase().replaceAll('-', '_');
  SNACKBAR_TEMPLATES[templateConstantKey] = templateId;

  templateMapping.set(templateId, snackbar);
});

export { templateMapping as Templates, SNACKBAR_TEMPLATES };
